import { render, staticRenderFns } from "./TreeQuestion.vue?vue&type=template&id=15c3d35c&scoped=true"
import script from "./TreeQuestion.vue?vue&type=script&lang=js"
export * from "./TreeQuestion.vue?vue&type=script&lang=js"
import style0 from "./TreeQuestion.vue?vue&type=style&index=0&id=15c3d35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3d35c",
  null
  
)

export default component.exports